import React, { Fragment } from 'react';
import { Alert, Button, Checkbox, Form, Input, Select, message } from "antd";
import './landingPage.css';
import LazyLoad from 'react-lazy-load';
import PropTypes from 'prop-types';
import CelaneseAPI from '../../services';
import { Combobox } from 'react-widgets';
import config, { utils } from '../../config';

const FormItem = Form.Item;
const Option = Select.Option;
class LandingPage extends React.Component {
    constructor(props) {
        super(props);
        this.loginOkta = this.loginOkta.bind(this);
        this.onRequestAccess = this.onRequestAccess.bind(this);
        this.state = {
            showThankyou: false,
            hidelogin: true,
            name: '',
            loading: false,
            countryNames: [],
            filteredCountryNames: [],
            countryOpen: false,
            authError: "",
        };
    }

    componentDidMount() {
        const authError = sessionStorage.getItem("authError");
        if (authError) {
            this.setState({ authError });
            sessionStorage.removeItem("authError");
        }
        this.getCountryNames();
    }

    loginOkta(){
        this.setState({
            loading: true
        });
        window.login();     
    }
    navigateToLogin = () => {
        this.setState({
            showThankyou: false,
            showRequestAccess: false,
            hidelogin: true,
            loading: false
        })
    }
    getCountryNames = (e) => {
        CelaneseAPI.get(config.API.countryNames).then(resp => {
            if (resp && resp.data) {
                this.setState({
                    countryNames: resp.data,
                    filteredCountryNames: resp.data
                });
            }
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let obj = {
                    'firstname': this.state.firstname,
                    'lastname': this.state.lastname,
                    'contact': this.state.contact,
                    'company': this.state.company,
                    'function': this.state.function,
                    'country': (this.state.userCountry),
                    'agreement': this.state.agreement,
                    'from': this.state.email,
                    'name': this.state.firstname + '' + this.state.lastname
                };
                let requstAccess = Object.assign(obj, values);
                this.setState({ 
                    name: requstAccess.firstname + ' ' + requstAccess.lastname,
                    loading: true
                });
                requstAccess.name = requstAccess.firstname + ' ' + requstAccess.lastname;
                if(requstAccess.contact === undefined){
                    requstAccess.contact = '';
                }
                if(requstAccess.country && typeof requstAccess.country === 'object') {
                    requstAccess.country = requstAccess.country.Name;
                }
                CelaneseAPI.post('/check-email', requstAccess).then((res) => {
                    if (res.error) {
                        this.error();
                        return;
                    }
                    else {
                        this.setState({ 
                            showThankyou: true, 
                            showRequestAccess: false,
                            hidelogin:false,
                            loading: false
                        });
                        if (res.data && res.data.message) {
                            message.warning(
                                utils.getTranslationText(
                                    'msg_register_user_send_invite_error',
                                    'User created successfully, but the invitation email could not be sent.'
                                ),
                                2
                            );
                        } else {
                            message.success(
                                utils.getTranslationText(
                                    'msg_register_user_send_invite',
                                    'User created successfully and the invitation email sent successfully.'
                                ),
                                2
                            );
                        }
                    }
                    
                });
            }
            else {
                this.error();
            }
        });
    }


    onRequestAccess(e) {
        e && e.preventDefault();
        this.setState({ 
            showRequestAccess: true,
            'firstname': '',
            'lastname': '',
            'contact': '',
            'company': '',
            'country': '',
            'agreement': '',
        });
    }

    render() {
        let ListItem = ({ item }) => (
            <Fragment>
                {item.name || item.Name}
            </Fragment>
        );
        const { getFieldDecorator } = this.props.form;
        return (
            <div className='container-fluid'>
                <div className="row landing-page">
                    <div className="landing-container col-md-4">
                        <div className="landing-content">
                            <div className="landing-logo">
                            <a>
                                <img src="./images/login-logo.png" alt="Logo for Celanese" />
                            </a>
                            <h1><img src="./images/towplus-orange-final.png" alt="TowPlus web" /></h1>
                            </div>
                            <div className={!this.state.showRequestAccess && this.state.hidelogin? 'login displayBlock': 'displayNone'}>
                                <div className="landing-desc">
                                    <h2 className="landing-desc-temp">For Desktop/Laptop <span>(Mobile devices coming soon)</span></h2>
                                    <h2>Calculate and predict the performance of an acetate filter and the effect on the smoke yield and deliveries</h2>
                                    <ul className='main-list'>
                                        <li>Cigarette and Filter Modeling (Mono-acetate filter, Kretek modeling, Charcoal filter modeling)</li>
                                        <li>Influence of Tow and Filter Characteristics on Product Capability, Smoke Yield and Firmness</li>
                                    </ul>
                                </div>
                                <Button type="primary" loading={this.state.loading} block onClick={this.loginOkta}>Login</Button>
                                {this.state.authError ? (
                                    <Alert
                                        className="login-error"
                                        message="Unable to sign in"
                                        description="Please verify your email and password. If you do not have an account, click Request Access below."
                                        type="error"
                                        showIcon
                                        closable
                                        onClose={() => {
                                        sessionStorage.removeItem("authError");
                                        this.setState({ authError: "" });
                                        }}
                                    />
                                    ) : null}
                                <div className="register">
                                    <p>Are you a new user ? <a href="#" onClick={(e) => this.onRequestAccess(e)}>Request Access</a></p>
                                    
                                </div>                                
                                <div className="copyright">
                                    <p>Contact <a href="mailto:towplus.support@celanese.com" className="contact">Celanese Global Technical Solutions</a></p>
                                    <div className="policy-links">
                                        <a href="https://www.celanese.com/legal/disclaimer" target="_blank" rel="noopener noreferrer">Disclaimer</a> &nbsp;|&nbsp;
                                        <a href="https://www.celanese.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">Celanese Data Privacy Policy</a>
                                    </div>
                                </div>
                            </div>
                            <div className={this.state.showRequestAccess? 'request-access displayBlock': 'displayNone'}>
                                <h2>Request Access</h2>
                                <p>We need the following details from you for providing the access</p>
                                <Form className='row' onSubmit={this.handleSubmit}>
                                    <div className='col-md-6 flush-left'>
                                        <FormItem
                                            label="Firstname"
                                            >
                                            {getFieldDecorator('firstname', {
                                                rules: [ {
                                                required: true, message: 'Please input your first name',
                                                }],
                                            })(
                                                <Input autoComplete='off' />
                                            )}
                                        </FormItem>
                                    </div>
                                    <div className='col-md-6 flush-right'>
                                        <FormItem
                                            label="Lastname"
                                            >
                                            {getFieldDecorator('lastname', {
                                                rules: [ {
                                                required: true, message: 'Please input your last name',
                                                }],
                                            })(
                                                <Input autoComplete='off' />
                                            )}
                                        </FormItem>
                                    </div>
                                    <FormItem
                                        label="E-mail"
                                        >
                                        {getFieldDecorator('from', {
                                            rules: [{
                                            type: 'email', message: 'The input is not valid E-mail!',
                                            }, {
                                            required: true, message: 'Please input your E-mail!',
                                            }],
                                        })(
                                            <Input autoComplete='off' />
                                        )}
                                    </FormItem>
                                    <FormItem
                                        label="Company"
                                        >
                                        {getFieldDecorator('company', {
                                            rules: [ {
                                            required: true, message: 'Please input your Company',
                                            }],
                                        })(
                                            <Input autoComplete='off' />
                                        )}
                                    </FormItem>
                                    <FormItem
                                        label="Function"
                                        >
                                        {getFieldDecorator('function', {
                                            rules: [ {
                                            required: true, message: 'Please select the function',
                                            }],
                                        })(
                                            <Select>
                                                <Option value="">Select</Option>
                                                <Option value="Operations/Quality">Operations/Quality</Option>
                                                <Option value="R&amp;D">R&amp;D</Option>
                                                <Option value="Procurement">Procurement</Option>
                                                <Option value="Business/Sales/Marketing">Business/Sales/Marketing</Option>
                                                <Option value="Other">Other</Option>
                                            </Select>
                                        )}
                                    </FormItem>
                                    <FormItem
                                        label="Country"
                                        >
                                        {getFieldDecorator('country', {
                                            rules: [ {
                                            required: true, message: 'Please input your Country',
                                            }],
                                        })(
                                            <Combobox
                                                caseSensitive={false}
                                                // open={this.state.countryOpen}
                                                onBlur={() => { this.setState({countryOpen: false }) }}
                                                busy={false}
                                                value={this.state.userCountry}
                                                onFocus={() => { this.setState({countryOpen: true }) }}
                                                onSelect={() => { this.setState({countryOpen: false }) }}
                                                onChange={(name) => {
                                                    this.setState({
                                                        userCountry: typeof name === 'string' ? name: name.Name,
                                                        filteredCountryNames: this.state.countryNames.filter(item => {
                                                            if (name && typeof name === 'string') {
                                                                return item['Name'].toLowerCase().indexOf(name.toLowerCase()) === 0;
                                                            }
                                                            return true;
                                                        })
                                                    });
                                                }}
                                                data={this.state.filteredCountryNames}
                                                messages={{
                                                    emptyList: "There are no items in this list" ,
                                                }}
                                                textField='Name'
                                                valueField='Name'
                                                itemComponent={ListItem}
                                            />
                                        )}
                                    </FormItem>
                                    <FormItem
                                        label="Contact Phone Number (optional)"
                                        >
                                        {getFieldDecorator('contact', {
                                            rules: [],
                                        })(
                                            <Input autoComplete='off' />
                                        )}
                                    </FormItem>
                                    
                                    <FormItem>
                                        {getFieldDecorator('agreement', {
                                            valuePropName: 'checked',
                                            rules: [{
                                                required: true, message: 'Please read and accept the terms and conditions',
                                            }]
                                        })(
                                            <Checkbox>
                                                I agree to the {/*<a href="/help/html/Licensing_Agreement.htm">terms and conditions</a>*/} <a href="https://www.celanese.com/disclaimer.aspx" target="_blank">Disclaimer</a> and <a href="https://www.celanese.com/privacy-policy.aspx" target="_blank">Privacy Policy</a>
                                            </Checkbox>
                                        )}
                                    </FormItem>
                                    <FormItem>
                                        <Button loading={this.state.loading} type="primary" htmlType="submit" className="m2-top">Submit</Button>
                                        <Button type="ghost" onClick={this.navigateToLogin} className="m2-top">Back</Button>
                                    </FormItem>
                                </Form>
                            </div>
                            <div className={this.state.showThankyou? 'thank-you displayBlock': 'displayNone'}>
                                <h2>Thank you {this.state.name} for providing your details</h2>
                                <h4>We’ll evaluate your details and activate your account. You’ll be notified on your mail address when the account is activated. We might reachout to you for any clarifications</h4>
                                <Button type="primary" onClick={this.navigateToLogin} className="m2-top">Done</Button>
                            </div>
                        </div>
                    </div>
                    <div className="landing-banner col-md-8 flush-left flush-right">
                        <LazyLoad>
                            <video id="myVideo" height="400" width="400" playsInline autoPlay muted loop preload="metadata">   
                                <source id="ss"  src="./images/video-loop.mp4" type='video/mp4' />
                            </video>
                        </LazyLoad>
                    </div>
                </div>
                
            </div>
        );
    }
}

const LoginPage = Form.create()(LandingPage);

export default LoginPage;

LandingPage.propTypes = {
    form: PropTypes.object
}


// WEBPACK FOOTER //
// ./src/containers/LandingPage/index.js